// import Cookies from 'js-cookie';

const user = {
  state: {
    // solutionBanner:"",
    currentToken: {},
    organizationCode: '',
    systemCode: '',

    organizationInfo: {}, // 当前企业信息
    systemInfo: {}, // 当前系统信息
    solutionInfo: {}, // 当前域名配置信息

    ticket: '',
    defaultTitle: '个人中心', //浏览器tab显示默认title
    platformCode: 'SYSTEM_PLATFORM_10', //运行的平台为浏览器
    CurrentTicket: null,
    standbyNum: 0,
    systemOpenInfo: {}, // 系统开放信息
  },
  mutations: {
    setUser(state, user) {
      state.currentToken = user
    },
    logout(state, vm) {
      state.currentToken = null
    },
    setSystemCode(state, value) {
      state.systemCode = value
    },
    setOrganizationCode(state, value) {
      state.organizationCode = value //url获取
    },
    setOrganization(state, value) {
      state.organizationInfo = value
    },
    setSolutionInfo(state, value) {
      state.solutionInfo = value
    },
    setSystemInfo(state, value) {
      state.systemInfo = value
    },
    setTicket(state, value) {
      state.ticket = value
    },
    setCurrentTicket(state, data) {
      state.CurrentTicket = data
    },
    setStandbyNum(state, data) {
      state.standbyNum = data
    },
    setSystemOpenInfo(state, info) {
      state.systemOpenInfo = info
    },
  },
  actions: {
    setSolution(context, vm) {
      return new Promise((resolve, reject) => {
        var url = `rest/index/getSolution?prefix=${window.location.hostname}`
        vm.$axios
          .get(url)
          .then((res) => {
            console.log(vm.$store.state.user.solutionInfo)
            if (res.data.data) {
              context.commit('setSolutionInfo', res.data.data)
              context.dispatch('setBrowser', vm)
            }
            resolve(res)
          })
          .catch((res) => {
            reject(res)
          })
      })
    },
    setBrowser(context, vm) {
      let data = context.state.solutionInfo
      let solutionBanner = context.state.solutionInfo.banner
      if (!data || !solutionBanner) {
        context.dispatch('setSolution', vm)
        return
      }
      //设置浏览器title
      vm.$nextTick(() => {
        if (data)
          document.querySelector('title').innerHTML = data.title + '-' + context.state.defaultTitle
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
        link.type = 'image/x-icon'
        link.rel = 'shortcut icon'
        if (data) link.href = data.favicon
        document.getElementsByTagName('head')[0].appendChild(link)
      })
    },
  },
}

export default user
